import { render, staticRenderFns } from "./TabsByBotsServer.vue?vue&type=template&id=76db4e94&scoped=true&"
import script from "./TabsByBotsServer.vue?vue&type=script&lang=js&"
export * from "./TabsByBotsServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76db4e94",
  null
  
)

export default component.exports